import { FC, useEffect, useState } from 'react';
import { UserProfile as SharedUserProfile } from '@hssoft/design-system-shared-lib';
import { useTranslation } from 'react-i18next';
import { Subscription } from 'rxjs';
import {
  TCompanyConfigs,
  companyConfigService,
} from '../../../../../../services/companyConfig/companyConfig.service';
import { authService } from '../../../../../../services/auth/auth.service';
import { SW_MESSAGE_TYPE } from '../../../../../../../serviceWorker/appInit';
import { clearClientStorage } from '../../../../../../helpers/storage';

export const UserProfile: FC = () => {
  const { t } = useTranslation();
  const [currentUser, setCurrentUser] = useState<TCompanyConfigs['currentUser'] | undefined>(
    companyConfigService.getCachedConfigs()?.currentUser,
  );

  useEffect(() => {
    let configsSub: Subscription | undefined;
    if (!currentUser) {
      configsSub = companyConfigService.getConfigs(true).subscribe((configs) => {
        setCurrentUser(configs?.currentUser);
      });
    }

    const signOutSub = authService.sub.signOut().subscribe(() => {
      // Reload page to reset all streams values.
      // App will be redirected to the login page after reload.
      window.location.reload();
    });

    return () => {
      configsSub?.unsubscribe();
      signOutSub.unsubscribe();
    };
  }, []);

  const handleLogout = () => {
    authService.pub.signOut();
    clearClientStorage();
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker?.controller?.postMessage({ type: SW_MESSAGE_TYPE.logOut });
    }
  };

  return (
    <SharedUserProfile
      name={currentUser?.name || t('common.no_data')}
      organization={currentUser?.company || undefined}
      avatarSrc={currentUser?.avatarUrl || undefined}
      onLogout={handleLogout}
    />
  );
};
